module.exports = __webpack_public_path__ + "img/img1.83067316.png";